<style scoped lang="less">
	@import '../../../assets/less/base.less';
	.productcenter-page {
		.productcenter-box {
			box-sizing: border-box;
			width: 100%;
			height: 689px;
			margin: 0 auto;
			background: url(../../../assets/images/productcenter.jpg) no-repeat top center;
			background-size: cover;
			padding-top: 239px;
			.productcenter-banner {
				width: 1050px;
				height: 36px;
				font-size: 36px;
				font-weight: bold;
				font-stretch: normal;
				line-height: 36px;
				color: #ffffff;
				margin: 0 auto;
				text-align: right;
			}
			.productcenter-banner2 {
				width: 1050px;
				height: 24px;
				font-size: 24px;
				font-weight: normal;
				font-stretch: normal;
				line-height: 24px;
				margin: 0 auto;
				color: #ffffff;
				text-align: right;
				margin-top: 30px;
			}
			.productcenter-banner3 {
				width: 1050px;
				height: 48px;
				margin: 0 auto;
				margin-top: 35px;
				a:first-child {
					width: 180px;
					height: 48px;
					background-image: linear-gradient(81deg, #fe3b7d 0%, #ff5e94 42%, #ff80ab 100%), linear-gradient( #ffffff, #ffffff);
					background-blend-mode: normal, normal;
					border-radius: 24px;
					float: right;
					font-size: 22px;
					color: #FFFFFF;
					cursor: pointer;
					display: block;
					text-align: center;
					line-height: 48px;
				}
				a:last-child {
					width: 180px;
					height: 48px;
					background-image: linear-gradient(81deg, #FD7602 0%, #F3A401 42%, #EBCC00 100%), linear-gradient( #ffffff, #ffffff);
					background-blend-mode: normal, normal;
					border-radius: 24px;
					float: right;
					font-size: 22px;
					color: #FFFFFF;
					cursor: pointer;
					display: block;
					text-align: center;
					line-height: 48px;
					margin-right: 30px;
				}
				a:hover {
					transition: all 0.5s;
					box-shadow: 0px 6px 26.7px 2.3px rgba(60, 0, 121, 0.4);
				}
			}
		}
		.productcenter-titleIcon {
			width: 54px;
			height: 61px;
			background: url(../../../assets/images/newlogo.png) no-repeat center center;
			background-size: 100% 100%;
			margin: 0 auto;
			margin-top: 67px;
		}
		.productcenter-title {
			width: 1200px;
			margin: 0 auto;
			text-align: center;
			line-height: 48px;
			font-size: 18px;
			color: #333333;
			margin-top: 50px;
			padding: 0 36px;
		}
		.productcenter-consult {
			width: 1100px;
			height: 500px;
			margin: 0 auto;
			margin-top: 120px;
			.productcenter-consult-left {
				width: 554px;
				height: 100%;
				float: left;
				p {
					width: 100%;
					float: left;
				}
				p:first-child {
					height: 30px;
					line-height: 30px;
					font-size: 30px;
					color: #333333;
					margin-top: 84px;
				}
				p:nth-child(2) {
					width: 121px;
					height: 7px;
					background-image: linear-gradient(16deg, #4b1db7 0%, #752cc7 50%, #9c3ad6 100%), linear-gradient( #4d22bd, #4d22bd);
					background-blend-mode: normal, normal;
					margin-top: 21px;
				}
				p:nth-child(3) {
					height: 30px;
					line-height: 30px;
					font-size: 30px;
					color: #333333;
					margin-top: 50px;
				}
				p:nth-child(4) {
					height: auto;
					line-height: 30px;
					font-size: 18px;
					color: #333333;
					margin-top: 28px;
				}
			}
			.productcenter-consult-right {
				width: 482px;
				height: 100%;
				float: right;
				position: relative;
				background: url(../../../assets/images/jc.png) no-repeat left bottom;
				background-size: 482px 449px;
				img {
					width: 131px;
					height: 206px;
					margin-left: 163px;
				}
			}
		}
		.productcenter-consult2 {
			width: 1100px;
			height: 483px;
			margin: 0 auto;
			margin-top: 80px;
			margin-bottom: 80px;
			.productcenter-consult-left {
				width: 565px;
				height: 100%;
				float: left;
				position: relative;
				background: url(../../../assets/images/whysdk.png) no-repeat left bottom;
				background-size: 565px 404px;
				img {
					width: 131px;
					height: 206px;
					margin-left: 184px;
					margin-top: 25px;
				}
			}
			.productcenter-consult-right {
				width: 505px;
				height: 100%;
				float: right;
				p {
					width: 100%;
					float: left;
				}
				p:first-child {
					height: 30px;
					line-height: 30px;
					font-size: 30px;
					color: #333333;
					margin-top: 100px;
					text-align: right;
				}
				p:nth-child(2) {
					width: 121px;
					height: 7px;
					background-image: linear-gradient(16deg, #4b1db7 0%, #752cc7 50%, #9c3ad6 100%), linear-gradient( #4d22bd, #4d22bd);
					background-blend-mode: normal, normal;
					margin-top: 21px;
					float: right;
				}
				p:nth-child(3) {
					height: 30px;
					line-height: 30px;
					font-size: 30px;
					color: #333333;
					margin-top: 50px;
					text-align: right;
				}
				p:nth-child(4) {
					height: auto;
					line-height: 30px;
					font-size: 18px;
					color: #333333;
					margin-top: 28px;
					text-align: left;
				}
			}
		}
	}
</style>
<template>
	<div class="productcenter-page">
		<div class="productcenter-box">
			<newnav/>
			<p class="productcenter-banner">广告变现之旅 从下载万咖智星SDK开始</p>
			<p class="productcenter-banner2">简单 强大的万咖智星集成</p>
			<p class="productcenter-banner3">
				<router-link to="/sdkdoc/androidsdkup" target="_blank">SDK更新日志</router-link>
				<router-link :to="{name:'login'}">下载SDK</router-link>
			</p>
		</div>
		<div class="productcenter-titleIcon"></div>
		<div class="productcenter-title">万咖智星移动广告SDK是您强大的变现工具。它不仅在减少延迟，广告质量控制方面表现出色，而且针对高质量的受众数据提供更多相关的广告，使您的需求多样化以增加收入。</div>
		<div class="productcenter-consult">
			<div class="productcenter-consult-left">
				<p>集成SDK的好处</p>
				<p></p>
				<p>针对高质量的受众数据提供更精准的广告</p>
				<p>万咖智星独特的SDK允许我们从设备中提取适当的数据，同时我们也可在万咖智星市场收集用户行为数据，这些数据提供了巨大的受众特征，使广告商能够提供高度相关的广告给用户。</p>
			</div>
			<div class="productcenter-consult-right">
				<img src="../../../assets/images/jcdp.png" />
			</div>
		</div>
		<div class="productcenter-consult2">
			<div class="productcenter-consult-left">
				<img src="../../../assets/images/sj.png" />
			</div>
			<div class="productcenter-consult-right">
				<p>为什么集成万咖智星SDK</p>
				<p></p>
				<p>轻量 高效 稳定</p>
				<p>通过集成万咖智星SDK，即可从量大质优的广告库中稳定获取广告资源，它们为您的广告位量身打造，并将其变得“寸土寸金”</p>
			</div>
		</div>
		<newfooter/>
	</div>

</template>
<script>
	import Newnav from '../common/Newnav.vue';
	import Newfooter from '../common/Newfooter.vue';
	export default {
		components: {
			Newnav,
			Newfooter
		},
		props: {},
		data() {
			return {

			};
		},
		methods: {

		},
		created() {

		},
		mounted() {

		}
	};
</script>



// WEBPACK FOOTER //
// src/pages/NewHome/ProductCenter/ProductCenter.vue